import { useUserStore } from '@/config/store/userStore'

const moduleId = 14

const canUserAccessModule = (user: any) => {
  return user.profile.modules?.ticket?.isAccess
}

export const guardTicketAccess = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const canAccess = canUserAccessModule(user)
  return canAccess || { name: 'Home' }
}

export const guardTicketShowAll = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const canAccess = user.profile.modules?.ticket?.showAll
  return canAccess || { name: 'Home' }
}
